export default function () {
  function toggleNav() {
    document.body.classList.toggle('nav-open');
  }

  function toggleBag(direction) {
    if (direction == 'open') {
      document.body.classList.add('cart-open');
      document.body.classList.remove('nav-open');
    } else if (direction == 'close') {
      document.body.classList.remove('cart-open');
    } else if (direction == 'toggle') {
      document.body.classList.toggle('cart-open');
      document.body.classList.remove('nav-open');
    }
  }

  function openCloseNav(direction) {
    if (direction == 'close') {
      document.body.classList.remove('ready');
      document.body.classList.remove('nav-open');
    }
    if (direction == 'open') {
      document.body.classList.add('nav-open');
    }
    if (direction == 'closesub') {
      document.body.classList.add('ready');
      document.body.classList.remove('nav-open');
    }
  }

function playPauseAudio(event) {
  var button = event.target;
  var audio = button.nextElementSibling;
  if (audio.paused === false) {
    button.classList.remove('playing');
    audio.pause();
  } else {
    button.classList.add('playing');
    audio.play();
  }
}  

  return {
    toggleNav,
    openCloseNav,
    toggleBag,
    playPauseAudio,
  };
}
